import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Alert from '../ui/Alert';
import Button from '../ui/Button';

/** Unauthenticated gate for hidden /admin/* routes — no Morpheus branding. */
export default function AdminSignInPrompt({ title }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-4">
        <h1 className="text-xl font-black">{title}</h1>
        <Alert tone="warning" className="text-sm font-bold">
          Sign in with Firebase to continue. Server allowlist controls access.
        </Alert>
        <Button type="button" variant="admin" onClick={() => navigate('/signup?mode=login')}>
          Sign in
        </Button>
        <p className="text-xs text-gray-500">
          <Link to="/" className="text-violet-400 hover:text-violet-300">Back to home</Link>
        </p>
      </div>
    </div>
  );
}
